import type { FC } from 'react';
import type { GameListItemDto } from '@/queries/games/games.schema';
import { useTranslations } from 'next-intl';
import GameCard from '@/components/entities/games/GameCard';
import GameSkeleton from '@/components/entities/games/GameCard/components/GameSkeleton';
import EmptyStateVisual from '@/components/shared/EmptyStateVisual';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { AppRoutes } from '@/i18n/constants';
import { GamesGrid } from './GameGrid';

interface GameListContentProps {
  isLoading: boolean;
  items?: GameListItemDto[];
  defaultPageSize: number;
  className?: string;
}
export const GameListContent: FC<GameListContentProps> = ({ isLoading, items, defaultPageSize, className }) => {
  const t = useTranslations('providers.game-list');

  const isMobile = useMediaQuery('(max-width: 768px)', { initializeWithValue: false });

  if (isLoading) {
    return (
      <GamesGrid className={className}>
        {Array.from({ length: defaultPageSize }).map((_, index) => (
          <GameSkeleton key={index} className="w-full h-full" showName={!isMobile} />
        ))}
      </GamesGrid>
    );
  }

  if (items && items.length > 0) {
    return (
      <GamesGrid className={className}>
        {items.map(game => (
          <GameCard
            key={game.id}
            {...game}
            id={game.id}
            showName={!isMobile}
            path={AppRoutes.gamesId(game.id)}
            className="justify-between h-full p-0"
            pictureClassName="w-full aspect-[155/207]"
          >
            {/* TODO: add rating when it will be available */}
            {/* {!isMobile && <RatingStars rating={0} size="sm" interactive maxRating={5} showValue className="mt-0.5" /> } */}
          </GameCard>
        ))}
      </GamesGrid>
    );
  }

  if (items) {
    return (
      <div className="flex flex-col items-center justify-center text-center">
        <div className="flex flex-col items-center justify-center text-center relative max-lg:mt-10.25 lg:mt-10.25">
          <EmptyStateVisual desktopImageClassName="mt-2.25" />
          <p className="text-white heading-h6 bottom-15 lg:bottom-20 mb-2.75">{t('empty-state-search-title')}</p>
        </div>
      </div>
    );
  }

  return null;
};
